export interface MarketerProduct {
    id: string;
    productName: string;
    productLogin: string;
    access: ServerMarketerAccess;
    placeIds: number[];
    isSaved: boolean;
    isRemoving: boolean;
}

export const MARKETERS_PREFIX = 'marketers';

export interface Marketer {
    id: string;
    login: string;
    fullName: string;
    ownProducts: MarketerProduct[];
}

export interface MarketersState {
    marketers: Marketer[];
    pageStatus: MarketersPageStates;
    allMarketers: Marketer[];
    filter: FilterParams;
}

export interface MarketerState {
    marketer: Marketer;
    pageStatus: MarketersPageStates;
    editProduct: MarketerProduct;
    gridOffset?: number;
}

export enum MarketerAccess {
    READONLY = 'Readonly',
    FULL = 'Full',
    BY_PLACE = 'By Place'
}

export interface FilterParams {
    products: string[];
    access?: ServerMarketerAccess;
    place?: number;
}

export enum MarketersPageStates {
    PENDING = 'PENDING',
    LOADING = 'LOADING',
    FETCH_FORM = 'FETCH_FORM',
    ACTION = 'ACTION',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
    NOT_FOUND = 'NOT_FOUND'
}

export interface ServerMarketer {
    clientId: number;
    productLogin: string;
    username: string;
    availableProducts: ServerMarketerProduct[];
}

export interface ServerMarketerProduct {
    productId: number;
    productName: string;
    productLogin: string;
    placeIds: number[];
    accessType: ServerMarketerAccess;
}

export enum ServerMarketerAccess {
    READONLY = 'READONLY',
    FULL = 'FULL',
    BY_PLACE = 'BY_PLACE'
}

export const ACCESS_SELECTORS = [
    { text: MarketerAccess.READONLY, val: ServerMarketerAccess.READONLY },
    { text: MarketerAccess.FULL, val: ServerMarketerAccess.FULL },
    { text: MarketerAccess.BY_PLACE, val: ServerMarketerAccess.BY_PLACE }
];
